import React from "react";
import { Routes, Route, Link, Outlet } from "react-router-dom";
import Auth from "../../utils/auth";
import ContactList from "../contact-list/contact-list";
import Addresses from "../address/addresses";
import BankList from "../bank-list/bank-list";
import Customer from "./customer";
import { Authorize } from "../../components/authorize";
import { withLocation } from "../../common/hocs";

class Client extends Authorize {
  state = {
    clientId: Auth.get("userId"),
    clientType: Auth.get("userType"),
    activeTabCls: "tab-pane fade",
    userMenu: [
      { title: "Clients", url: "/kyc/customer", active: true },
      { title: "Contacts", url: "/kyc/contacts", active: false, clientType: "Supplier" },
      { title: "Banks", url: "/kyc/banks", active: false, clientType: "Supplier" },
      { title: "Addresses", url: "/kyc/addresses", active: false },
      {
        title: "Business Entity",
        url: "/kyc/businessentity",
        active: false,
        clientType: "Supplier",
      },
    ],
  };

  handleActiveTab = (tabName) => {
    this.state.userMenu.map((tab) => {
      return tab.title === tabName ? (tab.active = true) : (tab.active = false);
    });
  };

  async componentDidMount() {
    if (
      this.props.context &&
      this.props.context.state.departments.length === 0
    ) {
      this.props.context.actions.setDepartments();
      await this.props.context.actions.setMasters();
    }
  }
  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let clientId = this.state.clientId;
    let clientType = this.state.clientType;

    // Use location from props (injected by wrapper)
    const loc = this.props.location.pathname;

    var links = this.state.userMenu.map((m) => {
      let isActive = false;
      let url = m.url;
      if (url !== "/" && loc.indexOf(url) > -1) {
        isActive = true;
      } else if (url === "/kyc/customer" && (loc === "/" || loc === "/kyc")) {
        isActive = true;
      }

      m.active = isActive;
      var activeClass = m.active ? "nav-item active" : "nav-item";
      var activeLink = m.active ? "nav-link active" : "nav-link";
      let showMenu =
        (m.clientType && this.state.clientType.indexOf(m.clientType) > -1) ||
          !m.clientType ? (
          <li key={m.title} className={activeClass}>
            <Link to={m.url} className={activeLink}>
              {m.title}{" "}
            </Link>
          </li>
        ) : (
          ""
        );
      return showMenu;
    });
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav>
              <ul className="nav nav-tabs mt-2 ml-2">{links}</ul>
            </nav>
            <div className="tab-content ml-2 mr-2 p-2 tab-content-wrapper">
              <Outlet context={{
                context: this.props.context,
                clientId: this.state.clientId,
                clientType: this.state.clientType,
              }} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// HOC to inject location function
export default withLocation(Client);